//Переменная кол-ва инициализированных свайперов
var scriptsReady = 0;
var imagesReady = 0;

//Проверка степени загрузки бэкграундов
$('.bg-image').imagesLoaded({
	background: true 
})
.done(function (instance) {
	imagesReady = 1;
})

// При загрузке всех картинок убирает основной прелоадер 
var hidePreloader1 = setTimeout(function checkImagesReady() {
		if (imagesReady == 1) {
			$('.preloader--1').fadeOut('slow', function () {});
			var data = global.getHash();
			if (data.name.length > 0) {
				var $hashTAB = $('.bottom-nav').find('.js-navigator[href="'+data.href+'"]');
				if ($hashTAB.length) $hashTAB.trigger('click');
			}
			return false;
		}
		hidePreloader1 = setTimeout(checkImagesReady, 100);
	}, 300);

// При нажатии на пункт меню определяется его хеш и добавляется в eq(), чтобы перейти потом на нужный таб
$('.bottom-nav__item').click(function() {
	var $this = $(this),
		hash = $this.data('hash');

//Анимация смены вида главной страницы
	$('.bottom-nav').velocity('transition.slideDownBigOut', 800)
	$('.main-page-heading').velocity('transition.fadeOut', 800)
	$('.bg-image--1').css('opacity', '0')

//После выполнения анимации открытия табов, скрипты инициализируются
	$('.main-page').velocity('transition.slideUpBigIn', {
		duration: 1200,
	    complete: function() { 
	       var swiper = new Swiper('.swiper-container--1', {
			    pagination: '.swiper-pagination--1',
			    direction: 'vertical',
			    slidesPerView: 1,
			    paginationClickable: true,
			    spaceBetween: 0,
			    speed: 600,
			    mousewheelControl: true,
			    simulateTouch: false,
			    onInit: function(){
			        scriptsReady++;
			    }
			});
			var swiper2 = new Swiper('.swiper-container--2', {
			    pagination: '.swiper-pagination--2',
			    direction: 'vertical',
			    slidesPerView: 1,
			    paginationClickable: true,
			    spaceBetween: 0,
			    speed: 600,
			    mousewheelControl: true,
			    simulateTouch: false,
			    onInit: function(){
			        scriptsReady++;
			    }
			});
			var swiper3 = new Swiper('.swiper-container--3', {
			    pagination: '.swiper-pagination--3',
			    direction: 'vertical',
			    slidesPerView: 1,
			    paginationClickable: true,
			    spaceBetween: 0,
			    speed: 600,
			    mousewheelControl: true,
			    simulateTouch: false,
			    onInit: function(){
			        scriptsReady++;
			    }
			});
	    }
	})
	$('.bottom-menu').velocity('transition.slideUpBigIn' ,1800)

//Проверка на степень загрузки скриптов, переод на нужный слайд, скрытие прелоадера
var hidePreloader2 = setTimeout(function checkScriptsReady() {
		if (scriptsReady == 3) {
			$('.main-page__content').hide();
			$('.js-main-tab-link').eq(hash).trigger('click');
			$('.preloader--2').fadeOut('slow', function () {});
			return false;
		}
		hidePreloader2 = setTimeout(checkScriptsReady, 100);
	}, 300);

function init_count_act(number) {
	if (scriptsReady == 3) {
	var $activeTab = $('.js-main-tab-link.is-current'),
		$currentBg = $('.bg-image.is-active'),
		numberActiveTab = $activeTab.data('item'),
		numberCurrentBg = $currentBg.data('bg'),
		numberNew = number;

		$('.main-page__content[data-id="'+numberActiveTab+'"]').hide();
		$('.bg-image[data-bg="'+numberCurrentBg+'"]').removeClass('is-active')
		$('.main-page__content[data-id="'+numberNew+'"]').velocity('transition.slideUpBigIn', 800)
		$('.bg-image[data-bg="'+numberNew+'"]').addClass('is-active')

	$activeTab.removeClass('is-current');
	}
}

//Функция, которая что-то делает :)
$('.js-main-tab-link').on('click touchstart', function (event) {
	// event.preventDefault();
	var $this = $(this),
		number = $this.data('item'),
		$navLine = $('.nav--main__line');

	if (!$this.hasClass('is-current')) {
		var position = 1024 + ($('.nav--main').offset().left - ($this.offset().left + $this.width() / 2));
		position = -position;

		$navLine.velocity({ 
			marginLeft: position,
			duration: 300
		});

		init_count_act(number);
		$this.addClass('is-current');
	}
});
});

// colorbox

$('.js-slide-zoom').colorbox({
	width: '1024px',
	innerWidth: '1024px',
	transition: 'elastic',
	speed: 300,
	fadeOut: 300,
	scalePhotos: true,
	inline: true
});

// end colorbox


var documentHeight = $(document).height(),
		windowHeight = $(window).height(),
		footerHeight = $('.wrapper--footer').height(),
		breakPointScroll = documentHeight - windowHeight - footerHeight;

setStaticPagenav();

$(window).on('scroll', setStaticPagenav);
$(window).on('resize', setStaticPagenav);
$('.bottom-nav').on('click', scrollUp);

function scrollUp() {
	$('html').velocity('scroll', {axis: '0'});
}

function setStaticPagenav() {
	documentHeight = $(document).height();
	windowHeight = $(window).height();
	breakPointScroll = documentHeight - windowHeight - footerHeight;

	if ($(window).scrollTop() >= breakPointScroll) {
		$('.bottom-nav')		
		.addClass('bottom-nav--fixed');
		if (windowHeight === documentHeight) {
			$('.bottom-nav')
				.removeClass('bottom-nav--fixed')
				.addClass('bottom-nav--abs');
		} else {
			$('.bottom-nav')
			.removeClass('bottom-nav--fixed')
			.addClass('bottom-nav--abs');
		}
	} else {
		$('.bottom-nav')
		.removeClass('bottom-nav--abs')
		.addClass('bottom-nav--fixed');
	}
}




/** WEBPACK FOOTER **
 ** ./frontend/components/main-page/main-page.js
 **/